export default __webpack_public_path__ + "static/media/gallery-heading.3bc76c70.png";